import { render } from "./ModuleFeatures.vue?vue&type=template&id=7472b4a8"
import script from "./ModuleFeatures.vue?vue&type=script&lang=js"
export * from "./ModuleFeatures.vue?vue&type=script&lang=js"

import "./ModuleFeatures.vue?vue&type=style&index=0&id=7472b4a8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__